import React from 'react';
import {StaticImage} from "gatsby-plugin-image";
import {FaFacebookF, FaInstagram} from "react-icons/fa";
import {IoLogoTiktok} from "react-icons/io5";

function TicInfoBox(props) {
    return (
        <div>
            <div className="rn-address bg_color--3">
                <div className="inner d-flex justify-content-center align-items-center flex-column text-center">
                    <div className="px-4 py-1">
                        <StaticImage
                            src="../../assets/images/rudnik/tic-litija-logo.png"
                            alt="TIC logo Litija"
                            placeholder="blurred"
                            imgClassName="img-fluid"
                            loading="lazy"
                        />
                    </div>

                    <h4 className="title text-center d-inline-block mt--15">Turistično informacijski center Litija – TIC Litija</h4>
                    <p>Valvazorjev trg 10, 1270 Litija</p>

                    <p className="mt--15">
                        <a href="mailto:info@visitlitija.si">info@visitlitija.si</a>
                    </p>

                    <p><a href="tel:+38651312739">051 312 739</a></p>
                    <p><a href="tel:+38670700484">070 700 484</a></p>

                    <p className="mt--15">
                        <a href="https://www.facebook.com/visitlitija/" target="_blank"><FaFacebookF />Facebook Visit Litija</a>
                    </p>

                    <p>
                        <a href="https://www.instagram.com/visitlitija/" target="_blank"><FaInstagram />Instagram Visit Litija</a>
                    </p>

                    <p className="mt--15">
                        <a href="https://www.facebook.com/rudniksitarjevec/" target="_blank"><FaFacebookF />Facebook rudnika</a>
                    </p>

                    <p>
                        <a href="https://www.instagram.com/rudnik_sitarjevec/" target="_blank"><FaInstagram />Instagram rudnika</a>
                    </p>

                    <p>
                        <a href="https://www.tiktok.com/@rudniksitarjevec" target="_blank"><IoLogoTiktok />TikTok rudnika</a>
                    </p>

                </div>
            </div>
        </div>
    );
}

export default TicInfoBox;
